/**
 * Where a created booking sends the passenger next.
 *
 * Baraka Pay hosts the checkout and returns an absolute URL the browser must go
 * to; the mock provider returns none and the page waits in place instead.
 *
 * The URL is CHECKED rather than trusted. It arrives over the API, and
 * `window.location.assign` will follow whatever it is handed — including
 * `javascript:`, which executes. "It comes from our own API" is exactly the
 * assumption that becomes an incident the day something upstream is influenced by
 * a third party. Only http(s) is ever navigated to.
 *
 * Same shape as KargoLink's `checkoutRedirectTarget`, deliberately: one payment
 * rail, one rule about following its links.
 */
export function checkoutRedirectTarget(created: { checkoutUrl?: string | null }): string | null {
  const url = created.checkoutUrl?.trim();
  if (!url) return null;

  try {
    const parsed = new URL(url);
    // `new URL` lower-cases the scheme and ignores leading whitespace, so
    // "\n JavaScript:" is caught here rather than needing its own rule.
    return parsed.protocol === 'https:' || parsed.protocol === 'http:' ? url : null;
  } catch {
    return null; // not a URL at all — never navigate to it
  }
}
